// vendor
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NotificationService } from '../services/notification.service';
import { WindowRefService } from '../services/window-ref.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment';
import { HttpErrorLoggerService } from '../services/http-error-logger.service';
import { maskUrlForLogging, buildAllowedHosts } from '../utils/datadog-log-sanitizer.util';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly allowedHosts = buildAllowedHosts(environment);

  constructor(
    private notificationService: NotificationService,
    private readonly windowRefService: WindowRefService,
    private readonly cookieService: CookieService,
    private readonly httpErrorLogger: HttpErrorLoggerService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      // Abort HTTP requests which are taking more than 3 min
      tap(
        (event) => {
          // do nothing
        },
        (error) => {
          const status = error?.status ?? 'unknown';
          const method = req.method ?? 'UNKNOWN';
          const urlTemplate = maskUrlForLogging(req.url ?? '', this.allowedHosts);
          this.windowRefService.nativeWindow.FS.log('HTTP error', { status, method, url_template: urlTemplate });
          switch (error.status) {
            case 400: {
              if (this.windowRefService.nativeWindow.location.pathname.includes('/redirect/products')) {
                this.windowRefService.nativeWindow.FS.event('[Auth] 400 Error');
                if (req.url === environment.customerGateway && req.method === 'GET') {
                  this.cookieService.deleteAll();
                  this.windowRefService.nativeWindow.location.href = '/login';
                }
              }
              break;
            }
            case 401: {
              if (this.windowRefService.nativeWindow.location.pathname.includes('/redirect/products')) {
                this.windowRefService.nativeWindow.FS.event('[Auth] 401 Error');
              }
              break;
            }
            case 403: {
              if (this.windowRefService.nativeWindow.location.pathname.includes('/redirect/products')) {
                this.windowRefService.nativeWindow.FS.event('[Auth] 403 Error');
              }
              break;
            }
            case 404: {
              if (this.windowRefService.nativeWindow.location.pathname.includes('/redirect/products')) {
                this.windowRefService.nativeWindow.FS.event('[Auth] 404 Error');
              }
              break;
            }
            case 500: {
              this.windowRefService.nativeWindow.FS.event('[Auth] 500 Error');
              break;
            }
          }

          // Forward the error to DataDog. The logger only reports genuine
          // backend/system failures (5xx and connectivity errors) and skips
          // user- or client-driven errors such as bad credentials.
          this.httpErrorLogger.logHttpError({ request: req, error });
        }
      )
    );
  }
}
